<template>
    <div class="base-open-service" :class="{'service-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="title">开服表</div>
            <div class="service-img" @click="$router.push('/base-service')">
                <img class="ser" src="~images/user_service.png" />
            </div>
        </div>
        <div class="list-box">
            <div v-if="isblank == true">
                <div class="header-title">
                    <div class="serveTime">开服时间</div>
                    <div class="serveName">服务器名</div>
                    <div class="las">开服提醒</div>
                </div>
                <div class="list" v-for="(item, index) in list" :key="index">
                    <div class="serveTime" v-if="istoday(item.start_time) == true"><span>今日</span> {{item.start_time | dasTime}}</div>
                    <div class="serveTime" v-if="istoday(item.start_time) == false">{{item.start_time | dateTime}}</div>
                    <div class="serveName">{{item.server_name}}</div>
                    <div class="las">
                        <div class="btn" :class="{isbtn: isopen(item.start_time) == true}" @click="onRemind(isopen(item.start_time))">
                            <span v-if="isopen(item.start_time) == true">已开服</span>
                            <span v-else-if="isopen(item.start_time) == false">提醒</span>
                            <span v-else>取消提醒</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="theblank" v-if="isblank == false">
                <TheBlank />
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <BaseRemind @childRemind='childRemind' v-if="isremind" />
        </transition>
    </div>
</template>

<script>
    import BaseRemind from './BaseRemind'
    import moment     from 'moment'
    import TheBlank   from '@/components/TheBlank'

    export default {
        name: 'BaseOpenService',
        components: {
            BaseRemind,
            TheBlank
        },
        data () {
            return {
                list: [],
                isremind: false,
                isblank: null
            }
        },
        computed: {
            // 是否开服
            isopen () {
                return (time) => {
                    let start = moment(new Date()).format('YYYY-MM-DD HH:mm')
                    let end = moment.unix(time).format('YYYY-MM-DD HH:mm')
                    return start > end
                }
            },
            // 是否今日开服
            istoday () {
                return (time) => {
                    let start = moment(new Date()).format('YYYY-MM-DD')
                    let end = moment.unix(time).format('YYYY-MM-DD')
                    return start == end
                }
            }
        },
        filters: {
            dasTime (time) {
                return moment.unix(time).format('HH:mm')
            },
            dateTime (time) {
                return moment.unix(time).format('MM-DD HH:mm')
            }
        },
        methods: {
            childRemind (event) {
                this.isremind = event
            },
            onRemind (status) {
                if (status == false) this.isremind = true
            },
            // 获取开服列表
            getList () {
                let accountData = JSON.parse(sessionStorage.getItem('accountData'))
                let options = {
                    appid: accountData.appid
                };
                options.sign = this.util.getSign(options, accountData.appkey)
                console.log(accountData,156165615615616161)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=BoxServer&a=getServerList', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.list = res.data.data
                        this.isblank = this.list.length > 0 ? true : false
                        sessionStorage.setItem('setService', JSON.stringify(this.list))
                    }
                })
            }
        },
        created () {
            if (sessionStorage.getItem('setService')) {
                let setService = JSON.parse(sessionStorage.getItem('setService'))
                this.list = setService
                this.isblank = this.list.length > 0 ? true : false
            } else {
                this.getList()
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-open-service {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .title {
                font-size: 51px;
                text-align: center;
            }
            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .ser {
                    width: 72px;
                    height: 72px;
                }
            }
        }
        .list-box {
            flex: 1;
            overflow-y: scroll;
            position: relative;
        }
        .header-title {
            width: 100%;
            height: 90px;
            color: $color;
            font-size: 42px;
            background: rgba($color, 0.2);
            padding: 0 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .list {
            height: 120px;
            font-size: 39px;
            border-bottom: 1px solid rgba(#e6e6e6, 0.5);
            padding: 0 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .btn {
                width: 180px;
                height: 72px;
                font-size: 36px;
                border-radius: 18px;
                background: $color;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .isbtn {
                background: rgba(255, 255, 255, 0.5);
            }
        }
        .list:last-child {
            margin-bottom: 60px;
        }
        .theblank {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .serveTime {
            width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .serveName {
            width: 430px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .las {
            width: 200px;
        }
    }
    // 竖屏css
    .service-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;
            .title {
                font-size: 92px;
            }
            .service-img {
                width: 290px;
                height: 240px;
                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .header-title {
            height: 163px;
            font-size: 76px;
            padding: 0 90px;
        }
        .list {
            height: 200px;
            font-size: 70px;
            padding: 0 90px;
            .btn {
                width: 327px;
                height: 130px;
                font-size: 65px;
                border-radius: 32px;
            }
        }
        .list:last-child {
            margin-bottom: 90px;
        }
        .serveTime {
            width: 500px;
        }
        .serveName {
            width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .las {
            width: 350px;
        }
    }
</style>